// The widget create/edit route shares the dashboard header but lives in its own
// widget-config flow.
const WIDGET_CONFIG_PATHNAME =
  "/[slug]/dashboard/[dashboardId]/widgets/configure/[widgetId]"

const DASHBOARD_INDEX_PATHNAME = "/[slug]/dashboard"
const DASHBOARD_DETAIL_PATHNAME = "/[slug]/dashboard/[dashboardId]"

// Routes that render the dashboard shell (tabs, header, name resolution).
// The widget-config route shares the dashboard header so it must be included.
const DASHBOARD_PATHNAMES = new Set([
  DASHBOARD_INDEX_PATHNAME,
  DASHBOARD_DETAIL_PATHNAME,
  WIDGET_CONFIG_PATHNAME,
])

export const isDashboardRoute = (pathname: string): boolean =>
  DASHBOARD_PATHNAMES.has(pathname)

// True on the widget create/edit page, where the dashboard-level "New Widget"
// action is redundant because the widget builder supplies its own actions.
export const isWidgetConfigRoute = (pathname: string): boolean =>
  pathname === WIDGET_CONFIG_PATHNAME
